import React from 'react'
import MediaAsset from '../media-asset'
import classnames from 'classnames'

const LightboxSlide = ({ slide, vw, vh, active }) => (
  <div className={classnames({'lightbox__slide--video-active': active}, 'lightbox__slide')} style={{
    height: vh
  }}>
    <div className="lightbox__media-item">
      <MediaAsset
        className="lightbox__media-image"
        active={active}
        usePlayer={slide.mediaSubType === 'video'}
        videoPosterSrc={ slide.media.poster && slide.media.poster.link }
        videoSrc={(active && slide.media.video) ? slide.media.video.link : null}
        videoWidth={slide.media.video && slide.media.video.width}
        videoHeight={slide.media.video && slide.media.video.height}
        src={slide.media.image && slide.media.image.link} />
    </div>
  </div>
)

export default LightboxSlide


// WEBPACK FOOTER //
// ./src/components/lightbox-container/lightbox-slide.js